import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createLead = async (payload) => {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
};

export const WHATSAPP_NUMBER = "41763822186"; // +41 76 382 21 86
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE_DISPLAY = "+41 76 382 21 86";
export const EMAIL = "info@consulting-ia.ch";
